export default __webpack_public_path__ + "static/media/pinMap.348ad96b.png";